// extracted by mini-css-extract-plugin
export default {"root":"S_Dgg7ee7IaRjejjEX7t"};